<template>
  <page>
    <page-title>Ui Elements Page</page-title>
    <switch-input
      v-model="isVerticalLayout"
      class="flowting-switch"
      direction="vertical"
      label="Enable Vertical Form Layout"
      name="vertical-layout"
    />
    <text-inputs :direction="direction" />
    <security-indicators :direction="direction" />
    <text-area-inputs :direction="direction" />
    <select-inputs :direction="direction" />
    <switch-inputs :direction="direction" />
    <button-inputs :direction="direction" />
    <radio-bar-inputs :direction="direction" />
    <tags-inputs :direction="direction" />
    <documents-inputs :direction="direction" />
    <notifications :direction="direction" />
    <dropdowns :direction="direction" />
    <nav-bars :direction="direction" />
    <modals :direction="direction" />
  </page>
</template>

<script>
import PageMixin from '@/mixins/pages/Page'
import ButtonInputs from './ButtonInputs'
import DocumentsInputs from './DocumentsInputs'
import Dropdowns from './Dropdowns'
import Modals from './Modals'
import NavBars from './NavBars'
import Notifications from './Notifications'
import PageTitle from '@/components/ui/PageTitle'
import RadioBarInputs from './RadioBarInputs'
import SecurityIndicators from './SecurityIndicators'
import SelectInputs from './SelectInputs'
import SwitchInputs from './SwitchInputs'
import SwitchInput from '@/components/forms/SwitchInput'
import TagsInputs from './TagsInputs'
import TextAreaInputs from './TextAreaInputs'
import TextInputs from './TextInputs'

export default {
  name: 'UiElementsPage',
  mixins: [PageMixin],
  components: {
    ButtonInputs,
    DocumentsInputs,
    Dropdowns,
    Modals,
    NavBars,
    Notifications,
    PageTitle,
    RadioBarInputs,
    SecurityIndicators,
    SelectInputs,
    SwitchInputs,
    SwitchInput,
    TagsInputs,
    TextAreaInputs,
    TextInputs
  },
  data () {
    return {
      isVerticalLayout: false
    }
  },
  computed: {
    direction () {
      return this.isVerticalLayout ? 'vertical' : 'horizontal'
    }
  },
  methods: {
    handleSubmit () {
      window.alert('submit')
    },
    handleCancel () {
      window.alert('cancel')
    }
  }
}
</script>

<style lang="sass">
.flowting-switch
  position: fixed !important
  top: 100px
  right: 100px
  text-align: right
  z-index: 10000
</style>



// WEBPACK FOOTER //
// src/pages/playground/UiElementsPage.vue